module.exports = __webpack_public_path__ + "static/media/css-animated-clock.d86086f4.mp4";